"use strict";

let ForShare = {
    options: {
        selector: ".for-share",
    },
};

ForShare.init = function (userOptions) {
    for (var prop in userOptions) {
        if (Object.prototype.hasOwnProperty.call(this.options, prop)) {
            this.options[prop] = userOptions[prop];
        }
    }

    this.initSelectors(document);
}

ForShare.initSelectors = function (rootElement) {
    let buttonElements = rootElement.querySelectorAll(this.options.selector);

    let self = this;

    buttonElements.forEach(function (buttonElement) {
        if (buttonElement.hasOwnProperty('moduleForShareInitialized')) { return; }
        buttonElement.moduleForShareInitialized = true;

        if (!navigator.share) { return; }

        buttonElement.classList.add('share-allowed');

        buttonElement.addEventListener("click", function (event) {
            event.stopPropagation();
            navigator.share({
                title: buttonElement.dataset.title,
                url: buttonElement.dataset.url,
                text: buttonElement.dataset.text,
            })
                .then(() => {
                    console.log("Shared!");
                })
                .catch((error) => {
                    console.error("Share error: ", error);
                });
        });
    });
}

export {ForShare};